// A stretch of signal for the glass to search. Fixed values rather than a
// runtime RNG so the picture is the same on every render -- an illustration,
// not a chart. Generated as a slow envelope (two incommensurate sines, so no
// section of it repeats) times a fast per-bar grain, which is what makes it
// read as recorded rather than drawn.
const BARS = [
  13.9, 16.3, 13.4, 20.0, 21.3, 16.0, 16.8, 20.0, 14.6, 23.5, 22.0,
  22.0, 11.4, 15.4, 8.5, 5.2, 5.2, 4.4, 5.8, 5.8, 10.3, 9.4,
  14.9, 10.9, 17.0, 19.6, 18.9, 18.2, 11.2, 12.9, 21.0, 16.1, 18.6,
  26.8, 15.1, 16.5, 15.5, 14.6, 15.6, 11.9, 5.6, 4.2, 5.6, 7.5,
]

const X0 = 6
const STEP = 5.3
const MID = 60
const LENS = { cx: 120, cy: 60, r: 37 }

// Kept in step with --nf-zoom in App.css: the magnified copy is scaled by this
// about the lens centre, and the sweep keyframes move it by -ZOOM times the
// lens's own offset so the right piece of signal stays under the glass.
const ZOOM = 1.75

function Waveform() {
  return (
    <g fill="var(--border-input)">
      {BARS.map((h, i) => (
        <rect
          key={i}
          x={X0 + i * STEP}
          y={MID - h}
          width="3.2"
          height={h * 2}
          rx="1.6"
          // Fades at both ends so the signal reads as continuing past the frame
          // rather than as a bounded object that happens to stop.
          opacity={Math.min(1, (i + 1) / 6, (BARS.length - i) / 6) * 0.6}
        />
      ))}
    </g>
  )
}

/**
 * Art for the not-found / no-access page.
 *
 * A waveform with a magnifying glass sweeping over it. The application is built
 * on exactly this picture -- sound levels over time -- so the search happens in
 * the material the product is made of.
 *
 * The glass really magnifies: a second copy of the waveform is scaled about the
 * lens centre and clipped to it, so what shows through the lens is the piece of
 * signal actually underneath. That takes two animations rather than one -- the
 * lens moves by d, and the magnified copy has to move by -ZOOM*d to keep the
 * same piece of signal in view. They are one curve sampled twice, with the same
 * duration and timing function, so they stay in step.
 *
 * The sweep is a lemniscate rather than a slide back and forth: it crosses its
 * own path, so the motion reads as searching rather than as a metronome, and
 * still closes on itself.
 *
 * Tokens throughout so it follows the theme. Decorative -- the heading beside
 * it carries the meaning -- so it is hidden from assistive tech.
 */
export default function NotFoundArt() {
  return (
    <svg className="notfound-art" viewBox="0 0 240 124" role="presentation" aria-hidden="true" fill="none">
      <defs>
        <clipPath id="nf-lens-clip">
          <circle cx={LENS.cx} cy={LENS.cy} r={LENS.r - 3} />
        </clipPath>
      </defs>

      <Waveform />

      <g className="notfound-lens">
        <g clipPath="url(#nf-lens-clip)">
          {/* Opaque, so the unmagnified bars do not show through the glass. */}
          <circle cx={LENS.cx} cy={LENS.cy} r={LENS.r - 3} fill="var(--surface)" />
          <g className="notfound-lens-view">
            <g transform={`translate(${LENS.cx} ${LENS.cy}) scale(${ZOOM}) translate(${-LENS.cx} ${-LENS.cy})`}>
              <Waveform />
            </g>
          </g>
        </g>

        <path d="M146 86 L172 112" stroke="var(--text-muted)" strokeWidth="9" strokeLinecap="round" />
        <circle cx={LENS.cx} cy={LENS.cy} r={LENS.r} stroke="var(--text-muted)" strokeWidth="6" />
      </g>
    </svg>
  )
}
